import { CodeRunnerRuntime, useRunCode, codeRunnerQueries } from '@/features/code-runner'
import { useSuspenseQuery } from '@tanstack/react-query'

export type UseCodeRunnerArgs = {
  id: number | undefined
  code: string
  runtime: CodeRunnerRuntime
  payload: any
}

export const useCodeRunner = ({ id, payload, code, runtime }: UseCodeRunnerArgs) => {
  const runCode = useRunCode(`${id}`)
  // @ts-ignore
  const { data } = useSuspenseQuery(codeRunnerQueries.list(`${id}`))

  const run = () => runCode.mutateAsync({ routeId: id, code, request: payload, configuration: { runtime } })

  return {
    result: data,
    run,
    isPending: runCode.isPending,
    isSuccess: runCode.isSuccess,
    isError: runCode.isError,
  }
}
